import { Headset, Mail } from "lucide-react";
import React from "react";
import { FaFacebook, FaLinkedin, FaYoutube } from "react-icons/fa";

const FooterVariacao = React.memo(() => {
  const socialLinks = [
    {
      href: "https://www.facebook.com/thopenergy/",
      label: "Facebook",
      icon: <FaFacebook color="#fff" className="w-6 h-6" />,
    },
    {
      href: "http://linkedin.com/company/thopenergy",
      label: "Linkedin",
      icon: <FaLinkedin color="#fff" className="w-6 h-6" />,
    },
    {
      href: "http://instagram.com/thopenergy",
      label: "Instagram",
      icon: (
        <img
          src="/tim/images/instagram-logo.svg"
          alt="Instagram"
          width={24}
          height={24}
          loading="lazy"
        />
      ),
    },
    {
      href: "https://www.youtube.com/@thopenergy/",
      label: "Youtube",
      icon: <FaYoutube color="#fff" className="w-6 h-6" />,
    },
  ];

  // Dados de contato extraídos para reduzir código repetitivo
  const contactInfo = [
    {
      icon: <Mail color="#fff" size={22} />,
      text: "contato@thopenergy.com.br",
      extraClasses: "pr-5",
    },
    {
      icon: <Headset color="#fff" size={22} />,
      text: "SAC (11) 4000-2022",
      extraClasses: "",
    },
  ];

  const year = new Date().getFullYear();

  const copyrightText = `© copyright ${year} © Grupo Thopen Energia . © TIM S/A. Todos os direitos reservados.`;

  return (
    <footer className="w-screen px-[20px] lg:px-[120px] py-16 pb-[10rem] bg-terciary-color justify-center items-center gap-2.5 flex">
      <div className="w-full max-w-[85rem] justify-center items-center gap-10 lg:gap-5 flex flex-col lg:flex-row">
        <div className="w-full flex flex-col gap-3">
          {/* Logos */}
          <div className="w-full mx-auto flex justify-center lg:justify-start items-center gap-6">
            <LogoLink
              href="https://www.tim.com.br/"
              src="/tim/images/logos/logo-tim.webp"
              alt="Logo TIM"
              width={90}
              height={30}
            />
            <LogoLink
              href="https://thopenergy.com.br/"
              src="/tim/images/logos/logo_topen_white.webp"
              alt="Logo Thopen"
              width={110}
              height={30}
            />
          </div>

          {/* Social Media Links */}
          <div className="flex items-center justify-center lg:justify-start gap-8 py-4">
            {socialLinks.map((link, index) => (
              <SocialLink key={index} href={link.href} label={link.label}>
                {link.icon}
              </SocialLink>
            ))}
          </div>

          {/* Copyright - Desktop */}
          <span className="text-sm font-normal text-white text-start hidden lg:block">
            {copyrightText}
          </span>
        </div>

        {/* Contact Information */}
        <div className="flex flex-col gap-6 lg:gap-4">
          <h4 className="font-bold text-sm text-white lg:text-start text-center">
            Central de Atendimento
          </h4>

          {contactInfo.map((info, index) => (
            <ContactItem key={index} extraClasses={info.extraClasses}>
              {info.icon}
              <span className="text-sm font-normal text-white">
                {info.text}
              </span>
            </ContactItem>
          ))}
        </div>

        {/* Copyright - Mobile */}
        <span className="text-sm font-normal text-white lg:text-start block lg:hidden text-center leading-loose">
          © copyright {year} © Grupo Thopen Energia .
          <br className="block lg:hidden" /> © TIM S/A. Todos os direitos
          reservados.
        </span>
      </div>
    </footer>
  );
});

// Componentes auxiliares memoizados para melhorar a performance
const LogoLink = React.memo(({ href, src, alt, width, height }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-80 transition-opacity duration-200"
    aria-label={alt}
  >
    <img
      src={src || "/placeholder.svg"}
      alt={alt}
      width={width}
      height={height}
      loading="lazy"
    />
  </a>
));

const SocialLink = React.memo(({ href, label, children }) => (
  <a
    href={href}
    className="hover:opacity-80"
    target="_blank"
    rel="noopener noreferrer"
    alt={label}
    aria-label={label}
  >
    {children}
  </a>
));

const ContactItem = React.memo(({ children, extraClasses }) => (
  <div
    className={`flex gap-2 items-center px-2 py-1.5 border border-white/70 rounded-lg ${extraClasses}`}
  >
    {children}
  </div>
));

FooterVariacao.displayName = "FooterVariacao";
LogoLink.displayName = "LogoLink";
SocialLink.displayName = "SocialLink";
ContactItem.displayName = "ContactItem";

export default FooterVariacao;
